import PropTypes from 'prop-types';

import TableComponent from '../Table/TableComponent';

const SpreadsheetTableComponent = (props) => {
  const { entries, columns } = props;
  if (!entries.length || !columns.length) return null;
  const tableProps = {
    tableId: 'import',
    columns,
    entries,
  };
  return <TableComponent {...tableProps} />;
};

SpreadsheetTableComponent.propTypes = {
  entries: PropTypes.instanceOf(Array).isRequired,
  columns: PropTypes.instanceOf(Array).isRequired,
};

export default SpreadsheetTableComponent;
